// Session timed out / token invalid: clear the dead token and bounce to
// the sign-in page from wherever we are. The route middleware only guards
// navigations, so without this a 401 mid-page leaves the user on a dead
// session watching every call silently fail.
function handleUnauthorized() {
  if (typeof window === 'undefined') return; // SSR — nothing to redirect
  // Already on the sign-in page (e.g. a bad-credentials 401) — don't loop.
  if (window.location.pathname.startsWith('/auth/signin')) return;
  try { localStorage.removeItem('token'); } catch (e) { /* ignore */ }
  const redirect = encodeURIComponent(window.location.pathname + window.location.search);
  window.location.href = `/auth/signin?redirect=${redirect}`;
}

export function handleError(error) {
  if (error && error.response) {
    if (error.response.status === 401) handleUnauthorized();
    return Promise.reject(error.response);
  }
  return Promise.reject(error);
}

// Any 2xx is a success. Axios only calls this on a status its validateStatus
// accepted, and nothing overrides the default (2xx), so the old list of
// 200/201/204 could not reject a real failure — it could only reject a
// SUCCESS whose code happened not to be on it. That is what it did: the
// Client Pack build endpoint moved to 202 Accepted when generation became a
// background job, and every "Generate Client Pack" click died here as
// "Unexpected response status: 202" while the build ran happily on the server.
export function handleResponse(response) {
  if (response.status === 204 || response.status === 205) {
    return null;
  } else if (response.status >= 200 && response.status < 300) {
    return response.data;
  } else if (response.status === 401) {
    handleUnauthorized();
    return Promise.reject(response);
  } else {
    throw new Error(`Unexpected response status: ${response.status}`);
  }
}
